import React from 'react';

import UserSelect from '~/components/Shared/UserSelect/UserSelect';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { TextArea } from '~/eds/src/components/TextArea/TextArea';
import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';
import { useIntl } from 'react-intl';
import Box from '~/ui/components/Box/Box';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import { CHARACTER_INPUT_LIMIT_LONG } from '~/ui/enums/input';

function NotificationItem({ notification, onRemove, onUpdate }) {
  const intl = useIntl();
  const formatNumber = useFormatNumber();
  const { id, message, userIds } = notification;

  function handleUserMultiSelectOnChange(selectedUserIds) {
    onUpdate(id, selectedUserIds, message);
  }

  function handleTextAreaChange(value) {
    onUpdate(id, userIds, value);
  }

  return (
    <FlexLayout flexDirection="column" space={3} bg="gray-200" px={6} py={4}>
      <FlexLayout alignItems="center" justifyContent="space-between" space={2}>
        <Box sx={{ flexGrow: 1 }}>
          <UserSelect
            enablePortal
            isMulti={true}
            name="notification-user-select"
            value={userIds}
            onChange={handleUserMultiSelectOnChange}
            width="100%"
          />
        </Box>
        <IconButton
          icon="trash"
          tooltip={intl.formatMessage({
            id: 'NotificationItem.removeTooltip',
            defaultMessage: 'remove',
            description: 'Tooltip for remove notification button',
          })}
          onClick={onRemove}
        />
      </FlexLayout>
      <FlexLayout flexDirection="column" space={2}>
        <FormField
          label={intl.formatMessage({
            id: 'NotificationItem.customMessageLabel',
            defaultMessage: 'Custom Message',
            description: 'Label for custom message textarea',
          })}
          input={TextArea}
          value={message}
          inputProps={{
            maxLength: CHARACTER_INPUT_LIMIT_LONG,
            onChange: (value) => {
              handleTextAreaChange(value);
            },
          }}
          footer={intl.formatMessage(
            {
              id: 'NotificationItem.customMessageFooter',
              defaultMessage: '{currentLength}/{maxLength} characters',
              description: 'Footer for custom message textarea',
            },
            {
              currentLength: formatNumber(message.length),
              maxLength: formatNumber(CHARACTER_INPUT_LIMIT_LONG),
            },
          )}
        />
      </FlexLayout>
    </FlexLayout>
  );
}

export default NotificationItem;
